import { render, staticRenderFns } from "./PublicAccess.vue?vue&type=template&id=8ad97d6a&"
import script from "./PublicAccess.vue?vue&type=script&lang=js&"
export * from "./PublicAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports